import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

// Translation provided by Vuetify (javascript)
import es from 'vuetify/lib/locale/es'


export default new Vuetify({
  lang:{
    locales: {es},
    current: 'es',
  },

  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#DA251C',
        secondary: '#F8C301',
        resaltar: '#F5F5F5',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
});
